export class GeneratedQRObject {
  constructor(public base64: string, public filename: string, public url: string) { }
}